import React from 'react';
import { IconChevronRight } from '@tabler/icons-react';
import AppIcon from '@/components/haccp/AppIcon';
import { cn } from '@/lib/utils';

export default function OperatorActionCard({ title, description, icon, onClick, className, compact = false, mobileWide = false }) {
  if (compact) {
    return (
      <button type="button" onClick={onClick} className={cn('klaro-action-card klaro-action-card--compact group text-left', className)}>
        <span className="klaro-action-card__visual"><AppIcon icon={icon} size="compactCard" /></span>
        <span className="min-w-0 flex-1">
          <span className="block truncate font-heading text-sm font-semibold text-[#0A1737]">{title}</span>
          {description && <span className="mt-0.5 block line-clamp-1 text-xs text-[#7B8AA7]">{description}</span>}
        </span>
      </button>
    );
  }

  return (
    <button
      type="button"
      onClick={onClick}
      className={cn('klaro-action-card group text-left', mobileWide && 'klaro-action-card--wide-mobile', className)}
    >
      <span className="klaro-action-card__visual" aria-hidden="true"><AppIcon icon={icon} size="card" /></span>
      <span className="klaro-action-card__content">
        <span className="min-w-0 flex-1">
          <span className="block font-heading text-[17px] font-semibold leading-tight text-[#0A1737] sm:text-[18px] xl:text-[19px]">{title}</span>
          <span className="mt-1.5 block text-[13px] leading-snug text-[#7B8AA7] sm:text-[14px] xl:text-[15px]">{description}</span>
        </span>
        <span className="klaro-action-card__arrow" aria-hidden="true"><IconChevronRight className="h-5 w-5" stroke={2} /></span>
      </span>
    </button>
  );
}
